module.exports = __webpack_public_path__ + "img/reestrator_mini.e37d86a5.png";